import { Owned } from './named';
import { IModel } from './annotation';
import { Metamodel } from './model';

export class ValidateInternalObject {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _aObject: any;
    private _model: IModel;

    constructor(private _object: {}, private _owned: Owned, private _ancestor: Owned) {
        this._model = Metamodel.modelOf(_object);
        this._owned = Owned.MODEL.isAncestor(this._model) ? _object as Owned : _owned;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._aObject = _object as any;
    }

    public get object(): {} {
        return this._object;
    }

    public get owned(): Owned {
        return this._owned;
    }

    public get ancestor(): Owned {
        return this._ancestor;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get aObject(): any {
        return this._aObject;
    }

    public get model(): IModel {
        return this._model;
    }
}
